import Collection from './Collection';

export default Collection;
export { Collection };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-virtualized/dist/es/Collection/index.js
// module id = 623
// module chunks = 0